var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#profile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10a8.75 8.75 0 1 1-17.5 0 8.75 8.75 0 0 1 17.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.234 17.34a5.3 5.3 0 0 1 2.757-2.575 5.172 5.172 0 1 1 4.015 0 5.3 5.3 0 0 1 2.756 2.574"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "profile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgProfile;